export default __webpack_public_path__ + "static/media/lost-white.84eed0d7.svg";